"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeployerSubPackage = void 0;
const deployer_1 = require("../logic/deployer");
class DeployerSubPackage {
    constructor(signer) {
        this.etherSigner = signer;
    }
    deployNewLiquidStakingDerivativeNetwork(daoAddress, stakehouseTicker, commission, gateKeeping) {
        return (0, deployer_1._deployNewLiquidStakingDerivativeNetwork)(this.etherSigner, daoAddress, stakehouseTicker, commission, gateKeeping);
    }
}
exports.DeployerSubPackage = DeployerSubPackage;
